import { Download, ExpandMore } from "@mui/icons-material";
import {
  Avatar,
  Box,
  Chip,
  Divider,
  FormControl,
  Grid2,
  Link,
  Menu,
  MenuItem,
  Select,
  Stack,
  Typography,
} from "@mui/material";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { shareCoverSheet } from "../../../../../api/Api";
import BookMarkIco from "../../../../../assets/icons/BookMarkIco";
import BriefCaseIco from "../../../../../assets/icons/BriefCaseIco";
import CalenderIco from "../../../../../assets/icons/CalenderIco";
import CandidateHub from "../../../../../assets/icons/CandidateHub";
import ClipBoardCheck from "../../../../../assets/icons/ClipBoardCheckIco";
import CopyIco from "../../../../../assets/icons/CopyIco";
import DotsVerticalIco from "../../../../../assets/icons/DotsVerticalIco";
import EyeIco from "../../../../../assets/icons/EyeIco";
import ScalesIco from "../../../../../assets/icons/ScalesIco";
import ShareIco from "../../../../../assets/icons/ShareIco";
import UsIco from "../../../../../assets/icons/UsIco";
import XCircleCloseIco from "../../../../../assets/icons/XCircleCloseIco";
import AvatarIco from "../../../../../assets/images/avatar.png";
import CommonButton from "../../../../../component/Button";
import SnackBar from "../../../../../component/SnackBar";
import { POST } from "../../../../../redux/axios/Axios";
import { HandleSkeletion } from "../../../../../utils/constants";
import CreateNote from "../../../../common-components/CreateNote";
import {
  CommonGrid2,
  DotColor,
  StyledFlexColumnView,
  StyledFlexRowView,
  SubTitleTypo,
  TitleTypo,
} from "../../../../common-components/StyledComponents";
import ShareQuickMatch from "../../../quick-match/components/ShareQuickMatch";
import { StyledSpaceBetweenBox } from "../../../quick-match/components/StyledComponent";
import DialogCandidateHub from "./DialogCandidateHub";
import ScheduleInterview from "./ScheduleInterview";
import AddUpdateActiveJob from "./AddUpdateActiveJob";
import SendAssessmentDialog from "./SendAssessmentDialog";
function Profile({
  isReviewCandidateProfile,
  matchedData,
  filteredResumeTab,
  resumeId,
  handleDownloadResume,
  isCandidatePerspectiveOpen,
  loading,
  handleChangeRequestInfo,
  handleClickAddNote,
}) {
  console.log({ matchedData });
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorElCompare, setAnchorElCompare] = React.useState(null);
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [openScheduleInterview, setScheduleInterview] = useState(false);
  const open = Boolean(anchorEl);
  const openCompare = Boolean(anchorElCompare);
  const [isLoading, setIsLoading] = useState(false);
  const [saveCandidateOpen, setSaveCandidateOpen] = useState(false);
  const [candidateProfileValue, setCandidateProfileValue] =
    useState("In Progress");
  const resumeIntelligence = useSelector(
    (state) => state.resumeIntelligence.resumeIntelligenceUpload
  );
  const [openActiveJobDialog, setOpenActiveJobDialog] = useState(false);
  const query = new URLSearchParams(useLocation().search);
  const dataLoading = loading;
  const [isRequestLoading, setIsRequestLoading] = useState(false);
  console.log({ resumeId });
  const [noteId, setNoteId] = useState("");
  const [noteList, setNoteList] = useState([
    { note: "Sample Note", interaction: "Email", added_by: "username" },
  ]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleShareClick = () => {
    setShareDialogOpen(true);
  };

  const handleChangeScheduleInterview = () => {
    setScheduleInterview(true);
    setAnchorEl(null);
  };
  const handleCloseScheduleInterview = () => {
    setScheduleInterview(false);
  };
  const [titleValue, setTitleValue] = useState("");
  const activeJobData = [
    {
      label: "Job",
      onChange: (e) => setTitleValue(e.target.value),
      value: titleValue,
    },
  ];

  const handleSaveToCandidatehub = () => {
    setAnchorEl(null);
    setSaveCandidateOpen(true);
  };
  const handleOpenActiveJobDialog = () => {
    setOpenActiveJobDialog(true);
    setAnchorEl(null);
  };
  const handleShareInvite = async (shareData) => {
    setIsLoading(true);
    try {
      // Simulate static content for share operation
      const payload = {
        url: window.location.href,
        to_mail: shareData.map((item) => item.email),
        cc_mail: [],
      };

      // Static response (mocked success message)
      const staticResponse = {
        message: "Job shared successfully!",
      };

      // Simulate success scenario after static data processing
      setAnchorEl(null);
      setSnackbarState({
        open: true,
        message: staticResponse.message,
        severity: "success",
      });

      // Close the share dialog
      setShareDialogOpen(false);
      setIsLoading(false);
    } catch (error) {
      // Simulate error scenario
      setAnchorEl(null);
      setSnackbarState({
        open: true,
        message: "Failed to share the job. Please try again.",
        severity: "error",
      });
      setIsLoading(false);
    }
  };

  const handleCloseValidation = () => {
    setSnackbarState((prev) => ({
      ...prev,
      open: false,
    }));
  };

  const handleCloseCompare = () => {
    setAnchorElCompare(null);
  };
  const handleClickCompare = (event) => {
    setAnchorElCompare(event.currentTarget);
  };
  const statusOptions = [
    { label: "Hired", color: "#17B26A" }, // Green
    { label: "In Progress", color: "#9E77ED" }, // Purple
    { label: "Rejected", color: "#F04438" }, // Red
  ];

  const handleCompareNavigate = (item) => {
    navigate(`/jobs/candidate/compare/${resumeId}/${item?.id}`);
  };
  const menuItems = [
    {
      label: "Share",
      icon: <ShareIco />,
      onClick: () => {
        handleShareClick();
        handleClose();
      },
    },
    {
      label: "Compare",
      icon: <CalenderIco />,
      onClick: () => {
        handleClose();
        navigate("/access-team-fit/compare");
      },
      // onClick: handleClose,
      ariaControls: open ? "basic-menu" : undefined,
      ariaHasPopup: "true",
      ariaExpanded: open ? "true" : undefined,
    },
    {
      label: "Add Note",
      icon: <ClipBoardCheck />,
      onClick: () => {
        handleClickAddNote();
        handleClose();
      },
    },
    {
      label: "Download",
      icon: <Download fontSize="12px" />,
      onClick: () => {
        // handleClickAddNote();
        handleClose();
      },
      // onClick: handleDownloadResume,
    },
    // {
    //   label: "View Resume",
    //   icon: <EyeIco size={"12px"} />,
    //   onClick: () => {
    //     navigate("/resumeScores");
    //     handleClose();
    //   },
    //   // onClick: () =>
    //   //   navigate(`/candidates/candidate-view?view-id=${matchedData.resume_id}`),
    // },
  ];
  const handleCreateNote = () => {
    handleClose();
  };

  const reviewCandidateProfileMenuItems = [
    {
      label: "Save to Candidate Hub",
      // disabled: query.get("resume") === "parse" ? false : true,
      icon: <BookMarkIco />,
      onClick: handleSaveToCandidatehub,
    },
    {
      label: "Match to Active Jobs",
      icon: <BriefCaseIco />,
      // disabled: true,
      onClick: handleOpenActiveJobDialog,
    },
    {
      label: "Close",
      icon: <XCircleCloseIco />,
      onClick: handleClose,
    },
    {
      label: "Send Assessments",
      // disabled: true,
      icon: <ClipBoardCheck />,
      onClick: handleChangeScheduleInterview,
    },
    {
      label: "Compare",
      // disabled: true,
      icon: <ScalesIco />,
      onClick: handleClose,
    },
  ];
  const [shareDialogOpen, setShareDialogOpen] = useState(false);

  const handleShareDialogClose = () => {
    setShareDialogOpen(false);
  };
  const handleSaveCandidate = () => {
    setSaveCandidateOpen(false);
  };
  const handleSave = async () => {
    setIsLoading(true);
    setTimeout(() => {
      setSnackbarState({
        open: true,
        severity: "success",
        message: "Saved successfully",
      });
      setSaveCandidateOpen(false);
      navigate("/resume-intelligence/create-candidate-resume");
    }, 200);
  };

  const handleCloseActiveJobDialog = () => {
    setOpenActiveJobDialog(false);
  };

  const Footer = () => (
    <CommonGrid2 display={"flex"} gap={"1rem"}>
      <CommonButton
        value={"Save"}
        width={"100%"}
        padding={"10px"}
        marginTop={"2rem"}
        fontWeight={"700"}
        fontSize={"15px"}
        disabled={isLoading}
        loading={isLoading}
        onClick={handleSave}
      />
    </CommonGrid2>
  );

  const gridData = [
    {
      title: "Current Title",
      contentKey: "Head of Customer",
    },
    {
      title: "Current Pay with Bonus",
      contentKey: "$100.000 ⏤ $120.000" || "-",
    },
    {
      title: "Location",
      contentKey: " San Francisco, California" || "-",
      icon: <UsIco />,
    },
    {
      title: "Website",
      isLink: true,
      website: "zahidmays.fyi",
    },
    // {
    //   title: "Lastest Rating",
    //   contentKey: "Exceeds" || "-",
    // },
  ];

  const reviewGridData = [
    // { title: "Visa Status", contentKey: "US Citizen" || "-" },
    // { title: "Seniority", contentKey: "Senior" || "-" },
    // {
    //   title: "Occupational Classification",
    //   contentKey: "Development" || "-",
    // },
    // { title: "Industry Experience", contentKey: "Technology" || "-" },
  ];
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const sendAssessmentItem = [
    { id: 1, label: "Technical", icon: <ShareIco /> },
    { id: 2, label: "Aptitude", icon: <CalenderIco /> },
    { id: 3, label: "Leadership", icon: <ClipBoardCheck /> },
  ];
  const handleOpenMenu = (event) => {
    setMenuAnchor(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setMenuAnchor(null);
  };

  const handleMenuItemClick = (item) => {
    setSelectedItem(item); // Store the selected item
    setDialogOpen(true); // Open the dialog
    handleCloseMenu(); // Close the menu
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  const handleAdd = (selectedValues) => {
    console.log(
      "Selected Values:",
      selectedValues,
      "Selected Item:",
      selectedItem
    );
    setDialogOpen(false);
  };

  return (
    <Grid2 container columnSpacing={4} rowSpacing={dataLoading ? 2 : 4}>
      {!query.get("view-id") && (
        <Grid2 size={12}>
          <Divider />
        </Grid2>
      )}
      {!isCandidatePerspectiveOpen && (
        <Grid2 size={12}>
          <StyledSpaceBetweenBox>
            <Stack direction="row" alignItems="center" spacing={2}>
              <Avatar
                alt="Zahir Mays"
                src={AvatarIco}
                sx={{
                  width: 64,
                  height: 64,
                  backgroundColor: "#F2F4F7",
                  color: "#667085",
                  // border: "1px solid #D0D5DD",
                  borderRadius: "unset",
                  borderTopLeftRadius: "30px",
                  borderTopRightRadius: "30px",
                  borderBottomLeftRadius: "30px",
                }}
              />
              <Box>
                <StyledFlexRowView>
                  <Typography fontSize={"24px"} fontWeight={600}>
                    {dataLoading ? (
                      <HandleSkeletion height={35} width={300} />
                    ) : (
                      "Zahir Mays"
                    )}
                  </Typography>
                  {isReviewCandidateProfile ? null : dataLoading ? (
                    <HandleSkeletion height={35} width={80} />
                  ) : (
                    <FormControl>
                      <Select
                        value={candidateProfileValue}
                        onChange={(e) => {
                          setCandidateProfileValue(e.target.value);
                        }}
                        displayEmpty
                        renderValue={(selected) => {
                          const selectedOption = statusOptions.find(
                            (option) => option.label === selected
                          );
                          return (
                            <Box display={"flex"} alignItems={"center"}>
                              <DotColor
                                color={selectedOption.color}
                                marginRight="8px"
                              />
                              <Typography>{selectedOption.label}</Typography>
                            </Box>
                          );
                        }}
                        IconComponent={ExpandMore}
                        sx={{
                          "& .MuiSelect-select": {
                            paddingLeft: "10px !important",
                            paddingTop: "1px !important",
                            paddingBottom: "1px !important",
                            display: "flex",
                            alignItems: "center",
                            borderRadius: "6px",
                            paddingRight: "25px !important",
                          },
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#D0D5DD",
                            boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
                          },
                          "& .MuiSelect-icon": {
                            fontSize: "14px",
                          },
                        }}
                      >
                        {statusOptions.map((option) => (
                          <MenuItem key={option.label} value={option.label}>
                            <Box display={"flex"} alignItems={"center"}>
                              {option.label}
                            </Box>
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  )}
                </StyledFlexRowView>

                {dataLoading ? (
                  <HandleSkeletion height={35} width={200} />
                ) : (
                  <>
                    {"zahir@untitledui.com" ? (
                      <Stack direction="row" alignItems="center" spacing={1}>
                        <Link
                          href={`mailto:${"zahir@untitledui.com"}`}
                          underline="none"
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            color: "#7F56D9",
                            fontSize: "16px",
                            fontFamily: "Inter",
                          }}
                        >
                          {"zahir@untitledui.com"}
                        </Link>
                        <CopyIco />
                      </Stack>
                    ) : null}
                  </>
                )}
              </Box>
            </Stack>

            {dataLoading ? (
              <HandleSkeletion height={100} width={200} />
            ) : (
              <StyledFlexRowView gap={"1.5rem"}>
                {isReviewCandidateProfile ? null : (
                  <CommonButton
                    value={"Send Assessments"}
                    padding={"10px 14px"}
                    variant="outlined"
                    size="small"
                    color={"#344054"}
                    border={"#D0D5DD"}
                    borderRadius="8px"
                    fontWeight={600}
                    onClick={handleOpenMenu}
                    // onClick={handleChangeScheduleInterview}
                  />
                )}
                <CommonButton
                  value={"Request Info"}
                  padding={"10px 14px"}
                  variant="outlined"
                  color={"#344054"}
                  border={"#D0D5DD"}
                  fontWeight={"600"}
                  onClick={handleChangeRequestInfo}
                  loading={isRequestLoading}
                  // disabled={true}
                />

                <div>
                  <CommonButton
                    value={<DotsVerticalIco />}
                    padding={"10px 14px"}
                    variant="outlined"
                    color={"#344054"}
                    border={"#D0D5DD"}
                    fontWeight={"600"}
                    aria-controls={open ? "basic-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? "true" : undefined}
                    onClick={handleClick}
                    minWidth={"20px !important"}
                  />

                  <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                      "aria-labelledby": "basic-button",
                    }}
                  >
                    {(isReviewCandidateProfile
                      ? reviewCandidateProfileMenuItems
                      : menuItems
                    ).map((item, index) => (
                      <MenuItem
                        key={index}
                        onClick={item.disabled ? () => {} : item.onClick}
                        aria-controls={item.ariaControls}
                        aria-haspopup={item.ariaHasPopup}
                        aria-expanded={item.ariaExpanded}
                        style={{ opacity: item.disabled ? 0.5 : 1 }}
                      >
                        <StyledFlexRowView>
                          {item.icon}
                          <Typography>{item.label}</Typography>
                        </StyledFlexRowView>
                      </MenuItem>
                    ))}
                  </Menu>

                  <Menu
                    id="basic-menu"
                    anchorEl={anchorElCompare}
                    open={openCompare}
                    onClose={handleCloseCompare}
                    MenuListProps={{
                      "aria-labelledby": "basic-button",
                    }}
                  >
                    {filteredResumeTab?.map((item, imdex) => (
                      <MenuItem
                        sx={{ marginTop: "10px" }}
                        onClick={() => handleCompareNavigate(item)}
                      >
                        <>
                          <ListItemIcon>
                            <Avatar
                              alt={"a"}
                              src="https://mui.com/static/images/avatar/1.jpg"
                              sx={{ width: 24, height: 24 }}
                            />
                          </ListItemIcon>
                          <ListItemText>
                            <Typography>{item?.name}</Typography>
                          </ListItemText>
                          <Chip
                            label={`${item?.score}%`}
                            variant="outlined"
                            size="small"
                            sx={{
                              paddingX: "5px",
                              paddingY: "1px",
                              marginLeft: "30px",
                            }}
                          />
                        </>
                      </MenuItem>
                    ))}
                  </Menu>
                </div>
              </StyledFlexRowView>
            )}
          </StyledSpaceBetweenBox>
        </Grid2>
      )}
      {gridData.map((item, index) => (
        // <Grid2 container spacing={3} display={"flex"} justifyContent={"space-between"}>
        <Grid2
          size={3}
          key={item.id}
          display={"flex"}
          justifyContent={"space-between"}
          gap={"1rem"}
        >
          {dataLoading ? (
            <HandleSkeletion height={50} />
          ) : (
            <StyledFlexColumnView gap={"6px"}>
              {item.title && <TitleTypo>{item.title}</TitleTypo>}

              {item.contentKey && (
                <>
                  <SubTitleTypo>{item.contentKey}</SubTitleTypo>
                  {index === 0 && (
                    <SubTitleTypo>{"Experience Strategy"}</SubTitleTypo>
                  )}
                </>
              )}

              {item.isLink && (
                <SubTitleTypo fontSize={"15px"} color="#6941C6">
                  {item.website}
                </SubTitleTypo>
              )}
            </StyledFlexColumnView>
          )}
        </Grid2>
        // </Grid2>
      ))}
      {isReviewCandidateProfile &&
        reviewGridData.map((item) => (
          <Grid2 size={3}>
            {dataLoading ? (
              <HandleSkeletion height={50} />
            ) : (
              <StyledFlexColumnView gap={"6px"}>
                <TitleTypo>{item.title}</TitleTypo>
                <SubTitleTypo>{item.contentKey}</SubTitleTypo>
              </StyledFlexColumnView>
            )}
          </Grid2>
        ))}
      {!isCandidatePerspectiveOpen && (
        <Grid2 size={12}>
          <Divider />
        </Grid2>
      )}
      <SnackBar
        snackbarState={snackbarState}
        handleCloseValidation={handleCloseValidation}
      />
      <ShareQuickMatch
        shareDialogOpen={shareDialogOpen}
        handleShareDialogClose={handleShareDialogClose}
        handleShareInvite={handleShareInvite}
        isLoading={isLoading}
      />
      <ScheduleInterview
        open={openScheduleInterview}
        onClose={handleCloseScheduleInterview}
        onApply={() => {
          handleCloseScheduleInterview();
        }}
      />
      <DialogCandidateHub
        open={saveCandidateOpen}
        handleClose={handleSaveCandidate}
        icon={<CandidateHub margin={"10px 0px 0px 10px"} />}
        footer={<Footer />}
        title="Save to Candidate Hub?"
        content={
          <>
            You are about to save a candidate under the name{" "}
            <strong style={{ fontWeight: 700 }}>
              {resumeIntelligence?.data?.personal_details?.candidate_name}
            </strong>{" "}
            and the role{" "}
            <strong style={{ fontWeight: 700 }}>
              {resumeIntelligence?.data?.personal_details?.inferred_title}
            </strong>{" "}
            in the Candidate Hub.
          </>
        }
      />
      <AddUpdateActiveJob
        open={openActiveJobDialog}
        onClose={handleCloseActiveJobDialog}
        activeOptions={activeJobData}
        onApply={() => {
          handleCloseActiveJobDialog();
        }}
        backgroundImage="path_to_background_image"
      />
      <Menu
        anchorEl={menuAnchor}
        open={Boolean(menuAnchor)}
        onClose={handleCloseMenu}
      >
        {sendAssessmentItem.map((item) => (
          <MenuItem
            key={item.id}
            style={{ gap: "10px" }}
            onClick={() => handleMenuItemClick(item)}
          >
            {item.icon} {item.label}
          </MenuItem>
        ))}
      </Menu>
      <SendAssessmentDialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        onAdd={handleAdd}
        title={`Choose Assessment for ${selectedItem?.label || ""}`}
        options={["Engine 1", "Engine 2", "Engine 3"]}
        engineLabel="Assessment Engine"
        assessmentLabel="Assessment"
      />
    </Grid2>
  );
}

export default Profile;
